import * as React from 'react'

import { cn } from '@/lib/utils'

export type TableShellProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> & {
  title?: React.ReactNode
  description?: React.ReactNode
  toolbar?: React.ReactNode
  actions?: React.ReactNode
  contentClassName?: string
}

/** 表格标准外壳：统一边框、标题/工具条区域与内容容器，适配高密度 PC 列表。 */
export function TableShell({
  title,
  description,
  toolbar,
  actions,
  className,
  contentClassName,
  children,
  ...props
}: TableShellProps) {
  const hasHeader = Boolean(title || description || actions)
  const hasToolbar = Boolean(toolbar)

  return (
    <div className={cn('rounded-lg border bg-card text-card-foreground', className)} {...props}>
      {hasHeader ? (
        <div className="flex items-start justify-between gap-6 border-b px-4 py-3">
          <div className="min-w-0 space-y-1">
            {title ? <h2 className="text-sm font-medium leading-none">{title}</h2> : null}
            {description ? (
              <div className="text-xs leading-5 text-muted-foreground">{description}</div>
            ) : null}
          </div>
          {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
        </div>
      ) : null}

      {hasToolbar ? <div className="border-b px-4 py-3">{toolbar}</div> : null}

      <div className={cn('min-w-0 overflow-x-auto', contentClassName)}>{children}</div>
    </div>
  )
}
